module.exports = __webpack_public_path__ + "static/media/fire-protection.a4f4c068.jpg";